import {Injectable} from '@angular/core';
import {Jsonp} from '@angular/http';

@Injectable()
export class ApiService {

  constructor(private jsonp: Jsonp) {}

  getFromApi(endpoint: string, params: any = {}) {
    const searchParams = Object.assign({callback: 'JSONP_CALLBACK'}, params);
    return this.jsonp.request(endpoint, {
      search: searchParams
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/api/api.service.ts